import { HelpCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { navIconButtonClass } from '@/components/layout/navIconButton';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { getHelpHashWithArticle, getHelpSlugForPath, getHelpTitleHint } from '@/lib/page-help';

type PageHelpButtonProps = {
  currentPath: string;
  onNavigate: (path: string) => void;
  className?: string;
};

/**
 * Opens Hilfe with the article that matches the current route (`?article=slug`).
 */
export function PageHelpButton({ currentPath, onNavigate, className }: PageHelpButtonProps) {
  const slug = getHelpSlugForPath(currentPath);
  const topic = getHelpTitleHint(currentPath);

  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={() => onNavigate(getHelpHashWithArticle(slug))}
          className={cn(navIconButtonClass, className)}
          aria-label={`Hilfe zu ${topic}`}
        >
          <HelpCircle className="h-[18px] w-[18px]" strokeWidth={2} />
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-xs text-left text-sm">
        <p className="font-medium">Hilfe zu dieser Seite</p>
        <p className="mt-1 text-muted">
          Öffnet die Dokumentation zum Thema «{topic}». Dort finden Sie Schritt-für-Schritt-Erklärungen und
          Best Practices.
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
